import { getApiBaseUrl } from '../config/config';

/**
 * Normalise une URL d'image pour éviter:
 * - mixed-content (http sur une page https) quand c'est le même host
 * - mauvais préfixage (relative vs absolute)
 *
 * @param {string | null | undefined} imagePath
 * @param {string | null} fallback
 * @returns {string | null}
 */
export function resolveMediaUrl(imagePath, fallback = null) {
  if (!imagePath) return fallback;

  // Images packagées côté frontend
  if (imagePath.startsWith('/images')) return imagePath;

  // Déjà une URL complète: on peut essayer d'upgrader http->https si même host
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    try {
      const url = new URL(imagePath);
      if (
        typeof window !== 'undefined' &&
        window.location.protocol === 'https:' &&
        url.protocol === 'http:' &&
        url.hostname === window.location.hostname
      ) {
        url.protocol = 'https:';
      }
      return url.toString();
    } catch {
      return imagePath;
    }
  }

  // Chemin relatif backend (ex: /media/...)
  if (imagePath.startsWith('/')) {
    return `${getApiBaseUrl()}${imagePath}`;
  }

  // Chemin relatif sans slash (rare)
  return `${getApiBaseUrl()}/${imagePath}`;
}


